<template>
  <v-container :fluid="$vuetify.breakpoint.lgAndDown">
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            <div>Mes BC</div>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Rechercher..."
              single-line
              hide-details
              outlined
              dense
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="computedHeaders"
            :options.sync="options"
            :server-items-length="total"
            :loading="loading"
            :items="orders"
            :search="search"
            class="elevation-1"
            :footer-props="{
              itemsPerPageOptions: [10, 30, 50],
              itemsPerPageText: 'Élements par page',
            }"
            @pagination="paginationUpdate"
          >
            <!-- eslint-disable -->
            <template
              v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }"
              >{{ pageStart }}-{{ pageStop }} de {{ itemsLength }}</template
            >
            <!-- eslint-enable -->
            <template v-slot:body="{ items }">
              <tbody class="text-left cursor-pointer">
                <tr
                  v-for="item in items"
                  :key="item._id"
                  @click="goToPurchaseOrder(item)"
                >
                  <td
                    :class="
                      item.deletedAt ? 'text-decoration-line-through' : ''
                    "
                  >
                    E-{{ item.orderId }}-{{ item.creatorTla }}
                  </td>
                  <td
                    :class="
                      item.deletedAt ? 'text-decoration-line-through' : ''
                    "
                  >
                    {{ item.supplier.name }}
                  </td>
                  <td
                    :class="
                      item.deletedAt ? 'text-decoration-line-through' : ''
                    "
                  >
                    {{
                      new Intl.NumberFormat("fr-CH", {
                        style: "currency",
                        currency: "CHF",
                      }).format(item.computedTotal)
                    }}
                  </td>
                  <td
                    :class="
                      item.deletedAt ? 'text-decoration-line-through' : ''
                    "
                  >
                    {{ item.year }}
                  </td>
                  <td
                    :class="
                      item.deletedAt ? 'text-decoration-line-through' : ''
                    "
                  >
                    {{ format(parseISO(item.poDate), "dd.MM.yyyy") }}
                  </td>
                  <td
                    :class="
                      item.deletedAt ? 'text-decoration-line-through' : ''
                    "
                  >
                    {{ item.projectNumber }}
                  </td>
                  <td
                    class="text-center"
                    v-if="$route.query.status === 'draft'"
                  >
                    <v-btn
                      v-if="!item.deletedAt && deleteConfirmation !== item._id"
                      small
                      text
                      @click.stop="setDeleteConfirmation(item._id)"
                      >Supprimer</v-btn
                    >
                    <v-btn
                      v-if="!item.deletedAt && deleteConfirmation === item._id"
                      small
                      color="error"
                      text
                      @click.stop="deleteItem(item._id)"
                      >Confirmer</v-btn
                    >
                    <div v-if="item.deletedAt">
                      {{ format(parseISO(item.deletedAt), "dd.MM.yyyy HH:mm") }}
                    </div>
                  </td>
                  <td v-else>
                    {{ item.lastValidation && item.lastValidation.fullname }} -
                    {{
                      item.lastValidation &&
                      format(
                        parseISO(item.lastValidation.createdAt),
                        "dd.MM.yyyy"
                      )
                    }}
                  </td>
                </tr>
              </tbody></template
            >
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" top right>
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.visible = false">
          Fermer
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import { debounce } from "lodash";
import Intl from "intl";
import { format, parseISO } from "date-fns";

export default {
  props: ["updateBadge", "setBadge"],
  async mounted() {
    // Initialize from URL parameters
    this.loadFromURL();
    await this.getDataFromApi();
  },
  data: () => ({
    snackbar: {
      visible: false,
      color: "",
      text: "",
    },
    orders: undefined,
    search: "",
    loading: false,
    deleteConfirmation: "",
    total: 0,
    deletedAt: false,
    options: {},
    headers: [
      {
        text: "N° BC",
        align: "start",
        value: "orderId",
      },
      { text: "Fournisseur", value: "supplier.name" },
      { text: "Montant", value: "computedTotal" },
      { text: "Année", value: "year" },
      { text: "Date de création", value: "poDate" },
      { text: "No et nom du projet", value: "projectNumber" },
      { text: "Suppression", sortable: false, align: "center" },
      { text: "En validation chez", sortable: false, align: "left" },
    ],
    Intl,
    format,
    parseISO,
  }),
  methods: {
    loadFromURL() {
      // Load search from URL
      if (this.$route.query.search) {
        this.search = this.$route.query.search;
      }

      // Load pagination options from URL
      if (this.$route.query.page) {
        this.options.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.itemsPerPage) {
        this.options.itemsPerPage = parseInt(this.$route.query.itemsPerPage);
      }
      if (this.$route.query.sortBy) {
        this.options.sortBy = this.$route.query.sortBy.split(',');
      }
      if (this.$route.query.sortDesc) {
        this.options.sortDesc = this.$route.query.sortDesc.split(',').map(d => d === 'true');
      }
    },

    updateURL() {
      const query = { ...this.$route.query };

      // Update search in URL
      if (this.search && this.search.trim()) {
        query.search = this.search.trim();
      } else {
        delete query.search;
      }

      // Update pagination in URL
      if (this.options.page && this.options.page > 1) {
        query.page = this.options.page;
      } else {
        delete query.page;
      }

      if (this.options.itemsPerPage && this.options.itemsPerPage !== 10) {
        query.itemsPerPage = this.options.itemsPerPage;
      } else {
        delete query.itemsPerPage;
      }

      if (this.options.sortBy && this.options.sortBy.length > 0) {
        query.sortBy = this.options.sortBy.join(',');
      } else {
        delete query.sortBy;
      }

      if (this.options.sortDesc && this.options.sortDesc.length > 0) {
        query.sortDesc = this.options.sortDesc.map(d => d.toString()).join(',');
      } else {
        delete query.sortDesc;
      }

      // Update URL without triggering navigation
      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.replace({ query }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },

    paginationUpdate(value) {
      if (this.$route.query && this.$route.query.status) {
        if (this.$route.query.status === "to-order") {
          this.setBadge("toOrder", value.itemsLength);
        }
        if (this.$route.query.status === "processing") {
          this.setBadge("processing", value.itemsLength);
        }
      }
    },
    async getDataFromApi() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/orders?page=${page}&sortBy=${sortBy}&sortDesc=${sortDesc}&itemsPerPage=${itemsPerPage}&search=${this.search}&deletedAt=${this.deletedAt}&status=${this.$route.query.status}`,
      });
      this.loading = false;
      let { docs: items } = data;
      const total = data.totalDocs;
      this.orders = items;
      this.total = total;
      this.updateURL();
    },
    setDeleteConfirmation(_id) {
      this.deleteConfirmation = _id;
    },
    async deleteItem() {
      try {
        const { data: deleted } = await axios({
          method: "delete",
          url: `${process.env.VUE_APP_API_URI}/orders/${this.deleteConfirmation}`,
        });
        this.orders.find((o) => o._id === this.deleteConfirmation).deletedAt =
          deleted.deletedAt;
        const status = this.orders.find(
          (o) => o._id === this.deleteConfirmation
        ).status;
        if (status === "draft") {
          this.updateBadge("drafts", -1);
        }
        if (status === "to-order") {
          this.updateBadge("toOrder", -1);
        }
        if (!this.deletedAt) {
          await this.getDataFromApi();
        }

        this.snackbar = {
          visible: true,
          color: "success",
          text: "Élément supprimé",
        };
      } catch (error) {
        this.snackbar = {
          visible: true,
          color: "error",
          text: "Erreur de suppression",
        };
      } finally {
        this.deleteConfirmation = "";
      }
    },
    goToPurchaseOrder(item) {
      // Build query params to preserve current search context
      const contextQuery = {};

      // Preserve search context from current route
      if (this.$route.query.search) {
        contextQuery.fromSearch = this.$route.query.search;
      }
      if (this.$route.query.page) {
        contextQuery.fromPage = this.$route.query.page;
      }
      if (this.$route.query.itemsPerPage) {
        contextQuery.fromItemsPerPage = this.$route.query.itemsPerPage;
      }
      if (this.$route.query.sortBy) {
        contextQuery.fromSortBy = this.$route.query.sortBy;
      }
      if (this.$route.query.sortDesc) {
        contextQuery.fromSortDesc = this.$route.query.sortDesc;
      }

      // Add current list context
      contextQuery.fromList = 'purchase-orders';
      contextQuery.fromStatus = this.$route.query.status;

      if (
        this.$route &&
        this.$route.query &&
        this.$route.query.status &&
        ['to-order', 'to-order-contractor'].indexOf(this.$route.query.status) !== -1
      )  {
        this.$router.push({
          path: `/orders/${item._id}/validations`,
          query: contextQuery
        });
      } else if (this.$route.query.status === 'archive') {
        this.$router.push({
          path: `/orders/${item._id}`,
          query: { ...contextQuery, detail: 'full' }
        });
      } else {
        this.$router.push({
          path: `/orders/${item._id}`,
          query: contextQuery
        });
      }
    }
  },
  watch: {
    async "$route.query.status"() {
      await this.getDataFromApi();
    },
    options: {
      async handler() {
        await this.getDataFromApi();
      },
      deep: true,
    },
    async deletedAt() {
      await this.getDataFromApi();
    },
    search: debounce(async function (value) {
      // Reset to first page when search changes
      this.options.page = 1;

      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/orders?page=${page}&sortBy=${sortBy}&sortDesc=${sortDesc}&itemsPerPage=${itemsPerPage}&search=${value}&deletedAt=${this.deletedAt}&status=${this.$route.query.status}`,
      });
      this.loading = false;
      let { docs: items } = data;
      const total = data.totalDocs;
      this.orders = items;
      this.total = total;
      this.updateURL();
    }, 500),
  },
  computed: {
    computedHeaders() {
      return this.$route.query.status !== "draft"
        ? this.headers.filter((h) => h.text !== "Suppression")
        : this.headers.filter((h) => h.text !== "En validation chez");
    },
  },
};
</script>